var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-drawer',{attrs:{"title":_vm.$t('linePushMessageLog.detail.title'),"visible":_vm.show,"size":"600px","append-to-body":true,"destroy-on-close":""},on:{"close":_vm.onClose}},[_c('div',{staticClass:"px-[24px]"},[_c('BlockSkeleton',{attrs:{"loading":!_vm.loaded,"width":"100%","height":"600px"}},[_c('BobDisplayForm',{attrs:{"config":{
          labelWidth: '128px',
          rowGap: 12,
        },"fields":_vm.displayFields}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }